export default {
	HISTORICO_REALINHAMENTO: 'historicoRealinhamento',
	HISTORICO_ALTERACAO_CLASSIFICACAO: 'historicoAlteracaoClassificacao',
	HISTORICO_ALTERACAO_FORNECEDOR: 'historicoAlteracaoFornecedor',
	HISTORICO_GERENCIA_SALDO_ITEM_ATA: 'historicoGerenciaDeSaldoItemAta',
	HISTORICO_BLOQUEIO: 'historicoBloqueio',
}
